<span class="cdp-select-summary-link" [hcPop]="summaryPop" trigger="click" title="See summary of selected items"
    >{{ items?.length }} {{ items?.length === 1 ? singularItemName : pluralItemName }} {{ linkText
    }}{{ hiddenRowText }}</span
>

<hc-pop #summaryPop [autoCloseOnContentClick]="true" [showArrow]="false" horizontalAlign="start">
    <div class="cdp-select-summary-pop-content">
        <div class="cdp-select-summary-pop-header">
            {{ items?.length }} {{ items?.length === 1 ? singularItemName : pluralItemName }} {{ popupText }}
        </div>
        <div class="cdp-select-summary-pop-items">
            <div
                class="cdp-select-summary-item {{ isItemNegated(item) ? 'cdp-select-summary-item-negated' : '' }}"
                title="{{ isItemNegated(item) ? negatedItemTooltip : '' }}"
                *ngFor="let item of items"
            >
                <div class="cdp-select-summary-pop-item-text">
                    <div class="cdp-select-summary-pop-item-text-inner" title="{{ item[primaryPropName] }}">
                        <span class="icon-left {{ primaryIcon }} primary-ico"></span>
                        <span>{{ item[primaryPropName] }}</span>
                    </div>
                    <div class="cdp-select-summary-pop-sub-item-text-container">
                        <div class="cdp-select-summary-pop-sub-item-text" title="{{ item[secondaryPropName] }}">
                            {{ item[secondaryPropName] }}
                        </div>
                        @if (tertiaryPropName) {
                            <div class="cdp-select-summary-pop-sub-item-text" title="{{ item[tertiaryPropName] }}">
                                {{ item[tertiaryPropName] }}
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div *ngIf="!(items?.length > 0)" class="cdp-select-summary-pop-empty">
                Select {{ pluralItemName }} from the list above
            </div>
        </div>
    </div>
</hc-pop>
